export { VehicleDescription } from './vehicle-description';
